import gql from "graphql-tag";

export const USER_REGISTER = gql`
  mutation RegisterUser(
    $mutationId: String!
    $email: String!
    $firstName: String!
    $lastName: String!
  ) {
    userRegister(
      input: {
        clientMutationId: $mutationId
        email: $email
        firstName: $firstName
        lastName: $lastName
      }
    ) {
      user {
        username
        userDetails {
          logins
          timeActive
        }
        name
      }
      authToken
    }
  }
`;

export const USER_LOGIN = gql`
  mutation LoginUser(
    $mutationId: String!
    $username: String!
    $password: String!
  ) {
    userLogin(
      input: {
        clientMutationId: $mutationId
        username: $username
        password: $password
      }
    ) {
      user {
        username
        userDetails {
          logins
          timeActive
        }
        name
      }
      authToken
    }
  }
`;

export const TRACK_ACTIVITY = gql`
  mutation TrackActivity(
    $mutationId: String!
    $action: String!
    $actionDate: String!
    $actionValue: String!
  ) {
    trackActivity(
      input: {
        clientMutationId: $mutationId
        action: $action
        actionDate: $actionDate
        actionValue: $actionValue
      }
    ) {
      user {
        username
        userDetails {
          activity {
            action
            actionDate
            actionValue
          }
        }
        name
      }
    }
  }
`;
